import { GettingStartedRootLink, ItemTypeConsts } from 'client/util/Constants';

import GettingStartedMdmVideo from 'client/GrowthEngineering/components/GettingStartedMdmVideo.vue';

const authNPoliciesGraphicSrc = `${GettingStartedRootLink.url}/getting-started-conditional-policies.png`;
const activeDirectoryGraphicSrc = `${GettingStartedRootLink.url}/getting-started-active-directory.png`;
const browserPatchManagementGraphicSrc = `${GettingStartedRootLink.url}/getting-started-bpm-empty-graphic.svg`;
const cloudDirectoryGraphicSrc = `${GettingStartedRootLink.url}/getting-started-cloud-directories.svg`;
const cloudInsightsGraphicSrc = `${GettingStartedRootLink.url}/getting-started-cloud-insights.svg`;
const commandGraphicSrc = `${GettingStartedRootLink.url}/getting-started-commands.svg`;
const configurationGraphicSrc = `${GettingStartedRootLink.url}/getting-started-policies.svg`;
const devicesGraphicSrc = `${GettingStartedRootLink.url}/getting-started-systems.svg`;
const hrDirectoryGraphicSrc = `${GettingStartedRootLink.url}/getting-started-workday.png`;
const hrDirectoriesGraphicSrc = `${GettingStartedRootLink.url}/getting-started-hr-directories.svg`;
const ldapGraphicSrc = `${GettingStartedRootLink.url}/getting-started-ldap.svg`;
const mdmGraphicSrc = `${GettingStartedRootLink.url}/getting-started-mdm.svg`;
const osPatchManagementGraphicSrc = `${GettingStartedRootLink.url}/getting-started-osp-empty-graphic.svg`;
const radiusGraphicSrc = `${GettingStartedRootLink.url}/getting-started-radius.svg`;
const softwareAppsGraphicSrc = `${GettingStartedRootLink.url}/getting-started-software-apps.png`;
const ssoGraphicSrc = `${GettingStartedRootLink.url}/getting-started-applications.svg`;
const systemUserGraphicSrc = `${GettingStartedRootLink.url}/getting-started-users.png`;

const gettingStartedGraphics = {
  default: {},
  [ItemTypeConsts.activeDirectory]: { component: 'img', src: activeDirectoryGraphicSrc },
  [ItemTypeConsts.authNPolicies]: { component: 'img', src: authNPoliciesGraphicSrc },
  [ItemTypeConsts.browserPatchManagement]: { component: 'img', src: browserPatchManagementGraphicSrc },
  [ItemTypeConsts.cloudDirectory]: { component: 'img', src: cloudDirectoryGraphicSrc },
  [ItemTypeConsts.cloudInsights]: { component: 'img', src: cloudInsightsGraphicSrc },
  [ItemTypeConsts.command]: { component: 'img', src: commandGraphicSrc },
  [ItemTypeConsts.commandResult]: { component: 'img', src: commandGraphicSrc },
  [ItemTypeConsts.configuration]: { component: 'img', src: configurationGraphicSrc },
  [ItemTypeConsts.configurationGroup]: { component: 'img', src: configurationGraphicSrc },
  [ItemTypeConsts.device]: { component: 'img', src: devicesGraphicSrc },
  [ItemTypeConsts.hrDirectories]: { component: 'img', src: hrDirectoriesGraphicSrc },
  [ItemTypeConsts.hrDirectory]: { component: 'img', src: hrDirectoryGraphicSrc },
  [ItemTypeConsts.ipList]: { component: 'img', src: authNPoliciesGraphicSrc },
  [ItemTypeConsts.ldap]: { component: 'img', src: ldapGraphicSrc },
  [ItemTypeConsts.mdmSettings]: { component: GettingStartedMdmVideo },
  [ItemTypeConsts.mdmVpp]: { component: 'img', src: mdmGraphicSrc },
  [ItemTypeConsts.osPatchManagement]: { component: 'img', src: osPatchManagementGraphicSrc },
  [ItemTypeConsts.radiusServer]: { component: 'img', src: radiusGraphicSrc },
  [ItemTypeConsts.softwareApps]: { component: 'img', src: softwareAppsGraphicSrc },
  [ItemTypeConsts.sso]: { component: 'img', src: ssoGraphicSrc },
  [ItemTypeConsts.systemUser]: { component: 'img', src: systemUserGraphicSrc },
  [ItemTypeConsts.vppApps]: { component: 'img', src: softwareAppsGraphicSrc },
};

export default gettingStartedGraphics;
